import React from 'react';
import {view, Icon, SelectFieldItem} from '@sail/ui';
import {info} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';
import {COLORS} from 'src/v2/util/color';
import {Text} from './Text';

interface SelectFieldItemWithTooltipProps {
  id: string;
  label: string;
  isDisabled: boolean;
  disabledTooltip?: string;
  iconElement?: IconAsset;
}

export const SelectFieldItemWithTooltip: React.FC<
  SelectFieldItemWithTooltipProps
> = ({id, label, isDisabled, disabledTooltip, iconElement}) => {
  const tooltipContent = isDisabled ? disabledTooltip : undefined;

  return (
    <SelectFieldItem key={id} id={id} aria-label={tooltipContent || label}>
      <view.div css={{display: 'contents'}} title={tooltipContent}>
        {iconElement ? (
          <Icon
            icon={iconElement}
            size="medium"
            css={{
              borderRadius: 'xsmall',
              color: isDisabled ? COLORS.textDisabled : COLORS.textPrimary,
              marginRight: 'small',
              order: -1,
              flexShrink: 0,
            }}
          />
        ) : null}
        <Text
          type="body"
          css={{
            color: isDisabled ? COLORS.textDisabled : COLORS.textPrimary,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            order: 0,
          }}
        >
          {label}
        </Text>
        {isDisabled ? (
          <Icon
            icon={info}
            size="xsmall"
            css={{
              color: COLORS.textDisabled,
              flex: 'none',
              order: 2,
              flexGrow: 0,
            }}
          />
        ) : null}
      </view.div>
    </SelectFieldItem>
  );
};
